import { observer } from "mobx-react"
import { Flex, Typography } from "antd"
import classNames from "classnames"

import pic from "@src/app/assets/mobile-screen-pic.svg"
import uiStore from "@src/app/uiStore"
import css from "./index.module.css"

export const MobileScreen = observer(() => {
  const { isTransferioTheme } = uiStore()

  return (
    <Flex
      className={classNames([
        css.container,
        { [`${css.containerTrans}`]: isTransferioTheme },
      ])}
      vertical
    >
      <Flex className={css.text} gap={5} vertical>
        <Typography.Title className={css.title}>Sorry</Typography.Title>
        <Typography.Text className={css.subtitle}>
          Mobile version is not supported, please open from desktop
        </Typography.Text>
      </Flex>

      {!isTransferioTheme && <img alt="pic" className={css.pic} src={pic} />}
    </Flex>
  )
})
